import { Text } from '@usap/uicomponents'
import React, { useCallback } from 'react'
import ChatWithUs from '../../RMA/Forms/ChatWithUs'
import useManageLifetimeButton from '../hooks/useManageLifetimeButton'
import { OrderDetailsButtonContainer } from './style/button.css'
import { returnType } from './type'

const LifetimeReplacement = ({ data }) => {
  const {
    showReturn,
    navigateToRMA,
    partNumber,
    orderId,
    itemDetails,
  } = { ...data }

  const actionButtonClick = useCallback(() => {
    navigateToRMA(orderId, partNumber, `${'returnType='}${returnType.lifetime}`)
  }, [orderId, partNumber, navigateToRMA])

  const {
    Button, label, disabled, withChat,
  } = useManageLifetimeButton({
    showReturn,
    itemDetails,
  })

  return (
    <OrderDetailsButtonContainer>
      <Button
        custom
        hideBorder
        disabled={disabled}
        onClick={actionButtonClick}
        label={<Text size="small">{label}</Text>}
      />
      {
        withChat && (
          <ChatWithUs />
        )
      }
    </OrderDetailsButtonContainer>
  )
}

export default LifetimeReplacement
